import React, { Suspense } from "react";
import { useTranslate } from "@tolgee/react";
import { usePageInit } from "src/common/hooks";
import { useLightMode } from "src/common/hooks/lightMode";
import { Loading } from "src/components";

const FareForecaster = React.lazy(() => import("./FareForecaster"));

function FareForecasterPage(props) {
  const { t } = useTranslate();
  usePageInit(`${t({ key: "common.smartPortal", defaultValue: "Smart Portal" })} - ${t({ key: "fareForecaster.title", defaultValue: "Fare Forecaster" })}`);
  const { lightMode } = useLightMode();
  return (
    <Suspense
      fallback={
        <Loading addContainer active loadingText={t({ key: "fareForecaster.loading", defaultValue: "Loading Fare Forecaster" })} />
      }
    >
      <FareForecaster {...props} lightMode={lightMode} />
    </Suspense>
  );
}

export default FareForecasterPage;
